const PrintApplicationTheme = {
  colors: {
    Brand1PenBlue: "#081e56",
    Brand11steplighter: "#0b2c7f",
    Brand12steplighter: "#0b37a7",
    Brand1PenBlue88: "rgba(8, 30, 86, 0.88)",
    Brand2Olivine: "#9eb25d",
    Brand21steplighter: "#abbf6d",
    Brand21steplighter2: "#b9cb7f",
    Brand3NaplesYellow: "#f1db4b",
    Brand31steplighter: "#fde966",
    Brand32steplighter: "#ffef85",
    Error: "#cc0202",
    Brand4LavenderWeb: "#e9ebf8",
    Brand5FrenchGrey: "#b4b8c5",
    GhostWhite: "#f4f4f9",
    White: "#ffffff",
    Grey10: "#efefef",
    Grey25: "#c0c0c0",
    PlaceholderGrey: "#a9a9a9",
    Grey50: "#7d7d7d",
    Black: "#000000",
    Transparent: "#ffffff",
    MobileMenuBG: "rgba(0, 0, 0, 0.8)",
  },
};

export default PrintApplicationTheme;
